import { render, staticRenderFns } from "./EventList.vue?vue&type=template&id=a8d6b468"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"
import style0 from "./EventList.vue?vue&type=style&index=0&id=a8d6b468&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports